import {
  useIsAuthPending as useIsAuthPendingBase,
  useIsLoggedIn as useIsLoggedInBase,
  useHasAllAccess as useHasAllAccessBase,
} from '@repo/cf-user/contexts/auth'
import { useForceIsAllAccess, useForceIsLoggedIn } from '../contexts/header-config-context'

/**
 * Returns whether the user is logged in, respecting the forceIsLoggedIn flag
 * from the header context for static variant rendering.
 */
export function useIsLoggedIn() {
  const forceIsLoggedIn = useForceIsLoggedIn()
  const isLoggedIn = useIsLoggedInBase()

  return isLoggedIn || forceIsLoggedIn === true
}

/**
 * Returns whether auth is still loading, respecting the forceIsLoggedIn flag.
 * When forceIsLoggedIn is set (true or false), we skip the loading state.
 */
export function useIsAuthPending() {
  const forceIsLoggedIn = useForceIsLoggedIn()
  const isPending = useIsAuthPendingBase()

  return isPending && forceIsLoggedIn === undefined
}

/**
 * Returns whether the user has an all access subscription, respecting the
 * forceIsAllAccess flag from the header context for static variant rendering.
 */
export function useHasAllAccess() {
  const forceIsAllAccess = useForceIsAllAccess()
  const isLoggedIn = useIsLoggedIn()
  const hasAllAccess = useHasAllAccessBase()

  return hasAllAccess || (isLoggedIn && forceIsAllAccess === true)
}
